import React from 'react'




/**
 * A component to display a field in a register header.
 * #registers
 * @param {string} title - The title of the field.
 * @param {string} data - The data of the field.
 * @returns {React.ReactElement} A React element representing a field in a register header.
 */
const RegisterHeaderField = ({title, data}) => {
  return (
    <div className='register-header-field'>
      <div className='title'>{title}</div>
      <div className='data'>{data}</div>
    </div>
  )
}

export default RegisterHeaderField
